export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'

export const STORE_CORE_AUTH = 'STORE_CORE_AUTH'

export const STORE_BUS_PROFILE = 'STORE_BUS_PROFILE'

export const STORE_MESSAGES = 'STORE_MESSAGES'

export const STORE_NOTIFICATION = 'STORE_NOTIFICATION'
